import React, { useEffect } from "react";
import { IErrorResponse } from "../types/ErrorResponse";
import { TProduct } from "../types/Product";
import ProductController from "../controllers/ProductController";

export interface IProductProp {
    id: string;
}

export const useProduct = ({ id }: IProductProp) => {
    const [loading, setLoading] = React.useState<boolean>(false);
    const [data, setData] = React.useState<TProduct | null>(null);
    const [error, setError] = React.useState<string>('');

    const execute = async () => {
        if (id === '' || id === 'new') {
            return;
        }

        if (!loading) {
            try {
                setLoading(true);

                if (error !== '') {
                    setError('');
                }
                if (data !== null) {
                    setData(null);
                }

                const response = await ProductController.get({ id });
                const responseError = response as IErrorResponse;
                const responseData = response as TProduct;

                if (responseError.code) {
                    setError(responseError.error);
                } else {
                    setData(responseData);
                }
            } catch (e) {
                var message = 'Erro não identificado';
                if (typeof e === "string") {
                    message = e.toUpperCase();
                } else if (e instanceof Error) {
                    const err = e as Error;
                    message = err.message;
                }
                setError(message);
            } finally {
                setLoading(false);
            }
        }
    }

    React.useEffect(() => {
        execute();
    }, []);

    const clear = () => {
        setError('');
    }

    return {
        loading,
        data,
        error,
        execute,
        clear,
    };
}